import routerOptions0 from "/app/cms_public/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.5.1_@types+node@24.0.3_db0@0.2.4_encoding@0.1.13_eslint@9.21.0__ijrpq5ytvfwjkbbwonfj4lr43u/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}